import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'
import { BP } from 'resources/constants'
import { containerCss } from 'app/sofia/components/Structure/Container'
import { sectionCss } from 'app/sofia/components/Structure/Section'
import { heading1 } from 'app/sofia/resources/theme/css'
import ShapeL from 'resources/svg/white-flowers-r.svg'

export const Section = styled.section`
  ${sectionCss};
  max-width: none;
  padding: 10px 0;
  position: relative;
  z-index: 1;

  &::after {
    background-size: ${BP.max} 44px;
    background-repeat: no-repeat;
    background-position: center 0;
    content: '';
    height: 44px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: none;
  }

  &.top {
    background: ${props => props.theme.palette.general.light};
    z-index: 5;

    &::before {
      content: '';
      width: 500px;
      height: 550px;
      position: absolute;
      background: url(${ShapeL}) no-repeat left top;
      bottom: -220px;
      left: -15%;
      z-index: -1;
      transform: rotate(340deg);

      @media (max-width: ${BP.md.max}) {
        content: unset;
      }
    }
  }

  &.middle {
    background: ${props => props.theme.palette.primary.alpha};
    z-index: 4;
    overflow: hidden;
    padding: 24px 0;
  }

  &.bottom {
    background: ${props => props.theme.palette.general.light};
    padding: 24px 0 80px;
  }
`

export const Container = styled.div`
  ${containerCss}

  @media (min-width: ${BP.md.min}) {
    width: ${BP.md.max};
  }

  .related-products {
    display: flex;
    justify-content: center;

    > div {
      flex: 1;
      max-width: 175px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin: 0 5px;
      background: ${props => props.theme.palette.general.light};
      border-radius: 4px;
      ${bp('sm')`
        button {
          margin: 0;
        }
      `}

      button {
        margin: 0 -25px -22px;
        border-radius: 0 0 4px 4px;
      }
    }

    a {
      display: block;
      margin: 10px 0;
      color: ${props => props.theme.palette.general.strong};
      text-decoration: none;
      min-height: 42px;
    }

    img {
      height: 135px !important;
      align-self: center;
    }

    .product-name {
      height: auto;
    }
  }

  .btn-link {
    ${props => props.theme.css.link};
    color: ${props => props.theme.productSelector.darkBg};
    height: auto;
    cursor: pointer;
    padding: 0;
    margin: 15px 0;
    border: 0;
    background: none;
    text-decoration: none;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      height: 20px;
      width: 20px;
      margin-left: 5px;

      path {
        fill: ${props => props.theme.productSelector.darkBg};
      }
    }

    > span {
      text-align: center;
      text-decoration: underline;
    }
  }

  .block-product {
    margin: 50px auto 40px;
    width: 80%;
    max-width: 820px;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 40px 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    box-shadow: ${props => props.theme.palette.general.boxShadow};
    ${bp('sm')`
      padding: 45px;
      width: 90%;
    `}

    h2 {
      margin-top: 0;
      font: ${font('alt', 'normal', '24px/1.2')};
    }

    > div {
      width: 45%;
      ${bp('sm')`
        width: 100%;
      `}

      &:first-child {
        margin-right: 20px;
        ${bp('sm')`
          margin: 0 0 20px 0;
        `}
      }
    }

    img {
      display: block;
      margin: auto;
      max-width: 100%;
    }

    .price {
      font: ${font('default', 'medium', '30px/1.2')};
      margin: 20px 0 14px;
    }
  }

  .button {
    ${props => props.theme.css.buttonPrimaryOutline};
  }

  .benefits {
    color: ${props => props.theme.palette.general.textColorLight};
    list-style: none;
    padding-left: 0;

    li {
      padding-left: 1em;
      text-indent: -1em;

      &::before {
        content: '>';
        padding-right: 5px;
      }
    }
  }
`

export const Product = styled.div`
  @media (min-width: ${BP.md.min}) {
    display: flex;
    flex-wrap: wrap;
    padding: 30px;
  }

  > div {
    box-sizing: border-box;

    &.side {
      margin-bottom: 30px;

      @media (min-width: ${BP.md.min}) {
        width: 50%;
        padding: 0 15px 20px 0;
        margin: 0 25px 0 0;
        border-right: 1px solid ${props => props.theme.palette.general.borderColorLight};
      }
    }

    &.content {
      flex: 1;
    }
  }

  h1 {
    ${props => props.theme.css.heading1};
    text-align: center;

    @media (min-width: ${BP.md.min}) {
      margin-top: 0;
    }
  }

  h2,
  h3 {
    ${props => props.theme.css.heading2};
  }

  h3 {
    font-size: 18px;
  }

  h4 {
    margin: 0;
  }

  h3,
  h4 {
    text-align: left;
    font-weight: ${props => props.theme.font.default.normal};
  }

  p {
    margin: 0;
    line-height: 1.35;
    color: ${props => props.theme.palette.general.textColor};

    strong {
      font-weight: ${props => props.theme.font.default.bold};
    }

    small {
      color: ${props => props.theme.palette.general.textColorLight};
      font-size: 14px;
    }

    &.promo-note {
      margin-bottom: 20px;
    }
  }

  hr {
    margin: 20px 0;
    height: 1px;
    background-color: ${props => props.theme.palette.general.borderColor};
    border: none;
  }

  .add-to {
    width: 100%;

    @media (max-width: ${BP.md.min}) {
      position: fixed;
      bottom: 15px;
      left: 15px;
      right: 15px;
      z-index: 9999999999;
      width: auto;

      button {
        width: 100%;
        padding: 18px;
      }
    }

    button {
      background-color: ${props => props.theme.palette.primary.beta};
      border-color: ${props => props.theme.palette.primary.beta};
    }
  }
`
export const Header = styled.header`
  text-align: center;
  margin-bottom: 20px;

  @media (min-width: ${BP.sm.min}) {
    margin-bottom: 35px;
  }

  h1,
  h2,
  h3 {
    ${heading1}
    margin: 0 0 5px;

    br {
      @media (min-width: ${BP.xs.min}) {
        display: none;
      }
    }
  }

  p {
    margin: 0 0 15px;
    line-height: 1.35;

    @media (min-width: ${BP.sm.min}) {
      font-size: 18px;
    }

    &:last-child {
      margin: 0;
    }
  }
`

export const FeaturedWrapper = styled.div`
  text-align: center;
  margin-top: 15px;

  h4,
  h5 {
    margin: 0 0 15px;
    font-size: 15px;
    font-weight: 600;
  }

  ul {
    display: flex;

    @media (min-width: ${BP.sm.min}) {
      justify-content: space-between;
      height: 100%;
    }

    li {
      flex: 1;
      padding: 0 5px;

      svg {
        background: ${props => props.theme.palette.general.strong};
        fill: ${props => props.theme.palette.general.light};

        * {
          stroke: ${props => props.theme.palette.general.light};
        }
      }
    }
  }
`

export const OptionsWrapper = styled.div`
  --spacingBase: 8px;

  margin: 10px 0;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  > div {
    @media (max-width: ${BP.sm.min}) {
      display: grid;
      grid-template-columns: repeat(3, minmax(160px, 1fr));
      padding: 0 0 15px;
      overflow: scroll;
    }

    @media (min-width: ${BP.sm.min}) {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-bottom: calc(var(--spacingBase) * -1);
      margin-left: calc(-1 * var(--spacingBase) / 2);
      margin-right: calc(-1 * var(--spacingBase) / 2);
    }

    > div {
      margin-bottom: 10px;

      &:last-child {
        @media (min-width: ${BP.sm.min}) {
          margin-bottom: var(--spacingBase);
        }
      }

      @media (min-width: ${BP.sm.min}) {
        margin-bottom: var(--spacingBase);
        margin-left: calc(var(--spacingBase) / 2);
        margin-right: calc(var(--spacingBase) / 2);
        flex: 1;
      }
    }
  }

  h4 {
    margin-top: 20px;
  }
`

export const Details = styled.div`
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: flex-start;

  * {
    box-sizing: border-box;
  }

  > div {
    align-self: flex-end;
    flex: 1 0 auto;
    width: 23%;
    margin: 0 5px;

    @media (max-width: ${BP.sm.max}) {
      flex: 1 0 50%;
      width: 50%;
      padding-top: 20px;
      padding-bottom: 20px;
      border-top: 1px solid ${props => props.theme.palette.general.borderColorLight};
      position: relative;

      &:nth-child(-n+2) {
        border-top: 0;
      }

      &:nth-child(odd) {
        padding-right: 20px;
      }

      &:nth-child(even) {
        padding-left: 20px;

        &::after {
          content: '';
          position: absolute;
          left: 0;
          top: 20px;
          bottom: 20px;
          width: 1px;
          background: ${props => props.theme.palette.general.borderColorLight};
        }
      }
    }

    p {
      text-align: left;

      > * {
        display: block;
        line-height: 1.4;
      }

      strong {
        font-weight: 700;
        font-size: 13px;

        &.md {
          font-size: 16px;
        }

        &.lg {
          font-size: 24px;
        }
      }

      span {
        font-size: 19px;
      }
    }
  }
`
export const DetailsMob = styled.div`
  text-align: center;

  p {
    margin: 0;
    line-height: 1.4;

    strong {
      font-weight: 700;
      font-size: 13px;

      &.md {
        font-size: 16px;
      }

      &.lg {
        font-size: 24px;
      }
    }
  }
`

export const BtnWrap = styled.div`
  margin-top: 40px;
  text-align: center;

  @media (min-width: ${BP.sm.min}) {
    margin-top: 20px;
  }

  button {
    width: 100%;

    @media (min-width: ${BP.xs.min}) {
      width: auto;
    }
  }
`
